import React, { useEffect, useState } from 'react'
import AudioPlayer from 'cwp-components/Multimedia/AudioPlayer'
import usePodcasts from 'common/providers/usePodcasts'
import PodcastsCard from 'cwp-components/cards/PodcastCard'
import { background } from 'assets/backgrounds'
import { useAudioPlayer } from 'cwp-components/Multimedia/useAudioPlayer'
import PodcastDescription from './PodcastDescription'

export interface Podcast {
  id: number
  tags: string[]
  areas: string[]
  sub_areas: string[]
  speakers: Speaker[]
  publisher: Publisher
  views_count: number
  created_at: string
  updated_at: string
  uuid: string
  slug: string
  publish_date: string
  title: string
  description: string
  url: string
  content: string
  transcript_file: string
  is_featured: boolean
  icon_image: string | null
  banner_image: string
  audio_file: string
  legal_services: any[]
}

export interface Speaker {
  id: number
  name: string
  avatar: string
  type: string
  linkedin_url: string | null
}

export interface Publisher {
  id: number
  name: string
  bio: string
  author_type: string
  avatar: string
  linkedin_url: string | null
}

const DiscoverPodcast = () => {
  const { getPodcasts } = usePodcasts()
  const [podcasts, setPodcasts] = useState<Podcast[]>([])
  const [featuredPodcast, setFeaturedPodcast] = useState<Podcast | undefined>(
    podcasts[0],
  )
  const recentPodcasts = podcasts.slice(0, 3)

  const audioPlayer = useAudioPlayer(featuredPodcast?.uuid)

  useEffect(() => {
    getPodcasts(
      { id: 1 },
      {
        onSuccess(data) {
          setPodcasts(data.results as Podcast[])
          setFeaturedPodcast(data.results[0] as Podcast)
        },
      },
    )
  }, [getPodcasts])

  return (
    <>
      <div className='relative w-full px-[10px] lg:px-[80px] mb-4 mt-[200px] max-sm:mt-2 '>
        <h1 className='text-[#101828]  text-[18px] lg:text-[40px] font-bold leading-normal tracking-[0.4px]'>
          Discover Law - Podcast
        </h1>
      </div>
      <div className='w-full px-[10px] lg:hidden'>
        <PodcastDescription />
      </div>
      <div
        className='relative lg:min-h-[530px]  h-auto   bg-cover bg-center bg-no-repeat w-full'
        style={{ backgroundImage: `url(${background.discoverLaw._04})` }}
      >
        {featuredPodcast && (
          <div
            className='relative h-auto bg-cover bg-center bg-no-repeat w-full'
            style={{ backgroundImage: `url(${background.discoverLaw._04})` }}
          >
            <div
              className='relative bg-cover bg-center bg-no-repeat w-full'
              style={{
                backgroundImage: `url(${background.discoverLaw._04})`,
              }}
            >
              <div className='px-[10px] lg:px-[80px] py-10'>
                <div className='flex flex-col lg:flex-row gap-6 lg:items-center'>
                  <div className='w-full lg:w-auto lg:flex-shrink-0'>
                    <AudioPlayer
                      audioPlayer={audioPlayer}
                      episode={featuredPodcast}
                      shareData={{
                        title: featuredPodcast.title,
                        url: featuredPodcast.url,
                      }}
                    />
                  </div>

                  <div className='w-full lg:flex-grow'>
                    <div className='p-5 bg-[#001A3D] rounded-xl h-full'>
                      <h3 className='font-semibold text-white mb-4'>
                        About this podcast
                      </h3>
                      <p className='text-sm text-white'>
                        {featuredPodcast.description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className='relative z-[2] w-full'>
        <div className='flex flex-col lg:flex-row gap:10 lg:gap-[42px] px-[10px] lg:px-[80px] rounded-lg lg:mt-[-150px] pb-[20px]'>
          <div className='hidden lg:block w-1/3'>
            <PodcastDescription />
          </div>
          <div className='w-full lg:w-2/3'>
            <div className='flex gap-6 overflow-x-auto snap-x snap-mandatory scroll-smooth sm:flex-wrap lg:grid lg:auto-rows-fr lg:grid-cols-3 lg:overflow-visible lg:snap-none'>
              {recentPodcasts.map((episode) => (
                <div
                  key={episode.uuid}
                  className='w-[80vw] max-w-sm sm:w-[45vw] lg:w-full shrink-0 snap-start lg:snap-auto min-h-[34rem]'
                >
                  <PodcastsCard
                    episode={episode}
                    className='w-full h-full flex flex-col'
                    onClickPlay={() => {
                      if (featuredPodcast === episode) return

                      setFeaturedPodcast(episode)
                      audioPlayer.reset()
                      setTimeout(() => {
                        const audio =
                          audioPlayer.audioRef.current?.audioEl?.current
                        if (audio) {
                          audio.play()
                        }
                      }, 0)
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
        <img
          src={background.discoverLaw._05}
          alt=''
          className='absolute w-full md:w-[75%] z-[-999] right-0 top-[80px]'
        />
      </div>
    </>
  )
}

export default DiscoverPodcast
